import { Box, Button } from '@cad-arc';

type ViewAllConversationsButtonParams = {
    isBookmarksView: boolean;
    paddingBottom?: string;
    setShowAllConversations?: (value: boolean) => void;
};

export const ViewAllConversationsButton: React.FC<ViewAllConversationsButtonParams> = ({
    isBookmarksView,
    paddingBottom,
    setShowAllConversations,
}) => {
    return (
        <Box
            w="100%"
            bg="var(--arc-colors-surface-foreground)"
            pt="var(--arc-space-2)"
            pb={paddingBottom}
        >
            <Button
                style={{ paddingLeft: '8px' }}
                data-testid="view-all-conversations-button"
                variant="ghost"
                leadingVisual="ArrowLeft"
                onClick={() => {
                    setShowAllConversations?.(true);
                }}
                size="lg"
            >
                {isBookmarksView ? 'View All Bookmarks' : 'View All Conversations'}
            </Button>
        </Box>
    );
};
